import React from "react";

const copyToClipBoard = e => {
  e.preventDefault();
  const email = document.getElementById("email");
  email.select();
  document.execCommand("copy");
};
export default () => (
  <section id="five" className="wrapper style2 special fade">
    <div className="container">
      <header>
        <h2>Contact me via email</h2>
        <p>I will respond within two hours</p>
      </header>
      <form
        method="post"
        action="#"
        className="cta"
        onSubmit={e => copyToClipBoard(e)}
      >
        <div className="row gtr-uniform gtr-50">
          <div className="col-8 col-12-xsmall">
            <input
              type="email"
              name="email"
              value="ispirett@gmail.com"
              readOnly
              id="email"
              placeholder="Your Email Address"
              style={{ fontWeight: 800 }}
            />
          </div>
          <div className="col-4 col-12-xsmall">
            <input type="submit" value="Copy Email" className="fit primary" />
          </div>
        </div>
      </form>
    </div>
    <script></script>
  </section>
);
